import React, { useState, useEffect } from "react";
import styled from "styled-components";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { RxCross2 } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

import { useSelector } from "react-redux";
import BASE_API_URL from "../../api/api";
import apiInstance from "../../Utils/api";
const Button = styled.button`
  background: rgb(0, 7, 51);
  color: white;
  justify-content: center;
  padding: 5px 10px;
  border: none;
  border-radius: 10px;
`;

const Create = () => {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  // const url = "http://192.168.1.3.:4000/api/";
  const api = apiInstance

  const [bankList, setBankList] = useState([]);
  const [cashList, setCashList] = useState([]);
  const [purchasePrice, setPurchasePrice] = useState("");
  const [changePurPrice, setChangePurPrice] = useState("");
  const [sellingPrice, setSellingPrice] = useState("");
  const [subQty, setSubQty] = useState(0);
  const [subPrice, setSubPrice] = useState(0);
  const [showBank, setShowBank] = useState(false);
  const [showCash, setShowCash] = useState(false);
  const [supplierCode, setSupplierCode] = useState("");
  const [supplierName, setSupplierName] = useState("");
  const [delID, setDelID] = useState("");
  const [units, setUnits] = useState([]);
  const [qty, setQty] = useState(0);
  const [price, setPrice] = useState("");
  const [medicines, setMedicines] = useState([]);
  const [procedures, setProcedures] = useState([]);
  const [proceduresAccess, setProceduresAccess] = useState([]);
  const [generalList, setGeneralList] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [value, setValue] = useState("");
  const [id, setId] = useState("");
  const [supId, setSupId] = useState("");
  const [date, setDate] = useState("");
  const [reqDate, setReqDate] = useState("");
  const [remark, setRemark] = useState("");
  const [reason, setReason] = useState("");
  const [expDate, setExpDate] = useState("");
  const [alertDate, setAlertDate] = useState("");
  const [totqty, setTotQty] = useState(0);
  const [totprice, setTotPrice] = useState(0);
  const [branchLists, setBranchLists] = useState([]);
  const [branch, setBranch] = useState("");
  const [medicineSale, setMedicineSale] = useState([]);

  const [initialAmount, setInitialAmount] = useState("");
  const [unit, setUnit] = useState("");
  const [code, setCode] = useState("");
  const [seq, setSeq] = useState("");

  const handleCashRadioChange = () => {
    setShowBank(false);
    setShowCash(true);
  };

  useEffect(() => {
    const getBankLists = async () => {
      try {
        const res = await api.get("accounting-lists");

        const bank = res.data.list.filter(
          (el) =>
            el.relatedHeader.name == "Cash At Bank" &&
            el.relatedType.name === "Assets",
        );
        setBankList(bank);
      } catch (err) {}
    };
    const getAccountingLists = async () => {
      try {
        const res = await api.get("accounting-lists");
        const medicineSale = res.data.list.filter(
          (e) =>
            e.relatedHeader.name == "Adminstrative exp" &&
            "Selling and distribution expense" &&
            "Personal expense" &&
            e.relatedType.name == "Profit and Loss",
        );
        setInitialAmount(medicineSale[0].amount);
        // setFinalAmount(medicineSale[0].amount);
        setMedicineSale(medicineSale);
        // setAccountingList(res.data.list);
        // set(
        //   res.data.list.filter((e) => e.relatedHeader.name == "Current Assets")
        // );
      } catch (err) {}
    };

    const getBanks = async () => {
      try {
        const res = await api.get("suppliers");
        setSuppliers(res.data.list);
        console.log("supp");
        console.log(suppliers);
      } catch (err) {}
    };
    const getBranches = async () => {
      try {
        const res = await api.get("branches");
        setBranchLists(res.data.list);
      } catch (err) {
        alert(err.message);
      }
    };
    const getCashLists = async () => {
      try {
        const res = await api.get("accounting-lists");

        const cash = res.data.list.filter(
          (el) =>
            el.relatedHeader.name == "Cash In Hand" &&
            el.relatedType.name === "Assets",
        );
        setCashList(cash);
      } catch (err) {}
    };

    const getCode = async () => {
      try {
        const res = await api.get("purchase-requests/code");
        setCode(res.data.data.code);
        setSeq(res.data.data.seq);
        // console.log(res.data.data, 'list')
      } catch (err) {
        alert(err.message);
      }
    };

    getCode();

    getCashLists();
    getBankLists();
    getBranches();
    getAccountingLists();
    getBanks();
  }, []);

  const chgItem = (val) => {
    if (val == 1) {
      getMedicines();
    }
    if (val == 2) {
      getProcedures();
    }
    if (val == 3) {
      getProceduresAccess();
    }
    if (val == 4) {
      getGeneral();
    }
  };
  const getMedicines = async () => {
    const res = await api.get("medicine-items");
    // console.log('bro!');
    console.log(res.data.list, "med");
    setUnits(res.data.list);

    setValue(1);
  };
  const getProcedures = async () => {
    const res = await api.get("procedure-items");
    setUnits(res.data.list);
    setValue(2);
  };

  const getProceduresAccess = async () => {
    const res = await api.get("accessory-items");
    setUnits(res.data.list);
    setValue(3);
  };

  const getGeneral = async () => {
    const res = await api.get("general-items");
    setUnits(res.data.list);

    setValue(4);
  };

  const chgQty = async (val) => {
    const res = units.filter((el) => el._id == val);
    // console.log('hi')
    console.log(res[0], "chg aty");
    setPurchasePrice(res[0]?.purchasePrice);
    setSellingPrice(res[0]?.sellingPrice);
    setUnit(res[0]?.unit);

    setId(val);
  };
  const addPurchase = async () => {
    const res = units.filter((el) => el._id === id);
    console.log(res, "add pur res");
    if (value === 1) {
      const obj = {
        item_id: id,
        name: res[0] ? res[0].medicineItemName : "",
        stockQty: res[0]?.currentQuantity,
        requestedQty: qty,
        recievedQty: 0,
        purchasePrice: purchasePrice,
        subTotal: parseInt(purchasePrice) * qty,
        totalUnit: (res[0]?.toUnit * qty) / res[0]?.fromUnit,
        expiredDate: expDate,
        alertDate: alertDate,
        // purchasePrice: res[0].purchasePrice,
        sellingPrice: res[0].sellingPrice,
      };
      // if (purchasePrice) {
      //   obj.purchasePrice = purchasePrice
      //   obj.sellingPrice = sellingPrice
      //   obj.subTotal = purchasePrice * qty
      // }
      // else {
      //   obj.sellingPrice = res[0]?.sellingPrice
      //   obj.subTotal = res[0]?.purchasePrice * qty
      //   obj.purchasePrice = res[0]?.purchasePrice
      // }

      setMedicines((arr) => [...arr, obj]);
    }
    if (value === 2) {
      const obj = {
        item_id: id,
        name: res[0] ? res[0].procedureItemName : "",
        stockQty: res[0]?.currentQuantity,
        requestedQty: qty,
        recievedQty: 0,
        purchasePrice: purchasePrice,
        subTotal: parseInt(purchasePrice) * qty,
        totalUnit: (res[0]?.toUnit * qty) / res[0]?.fromUnit,
        expiredDate: expDate,
        alertDate: alertDate,
        // purchasePrice: res[0].purchasePrice,
        // sellingPrice: res[0].sellingPrice,
      };
      // if (purchasePrice) {
      //   obj.purchasePrice = purchasePrice
      //   obj.sellingPrice = sellingPrice

      //   obj.subTotal = purchasePrice * qty
      // } else {
      //   obj.sellingPrice = res[0]?.sellingPrice

      //   obj.subTotal = res[0]?.purchasePrice * qty
      //   obj.purchasePrice = res[0]?.purchasePrice
      // }

      setProcedures((arr) => [...arr, obj]);
    }

    if (value === 3) {
      const obj = {
        item_id: id,
        name: res[0] ? res[0].accessoryItemName : "",
        stockQty: res[0]?.currentQuantity,
        requestedQty: qty,
        recievedQty: 0,
        purchasePrice: purchasePrice,
        subTotal: parseInt(purchasePrice) * qty,
        totalUnit: (res[0]?.toUnit * qty) / res[0]?.fromUnit,
        expiredDate: expDate,
        alertDate: alertDate,
        // purchasePrice: res[0].purchasePrice,
        // sellingPrice: res[0].sellingPrice,
      };
      // if (purchasePrice) {
      //   obj.purchasePrice = purchasePrice
      //   obj.sellingPrice = sellingPrice

      //   obj.subTotal = purchasePrice * qty
      // } else {
      //   obj.sellingPrice = res[0]?.sellingPrice

      //   obj.subTotal = res[0]?.purchasePrice * qty
      //   obj.purchasePrice = res[0]?.purchasePrice
      // }

      setProceduresAccess((arr) => [...arr, obj]);
    }
    if (value === 4) {
      const obj = {
        item_id: id,
        name: res[0]
          ? res[0]?.accessoryItemName || res[0]?.generalItemName
          : "",
        stockQty: res[0]?.currentQuantity,
        requestedQty: qty,
        recievedQty: 0,
        purchasePrice: purchasePrice,
        subTotal: parseInt(purchasePrice) * qty,
        totalUnit: (res[0]?.toUnit * qty) / res[0]?.fromUnit,
        expiredDate: expDate,
        alertDate: alertDate,
        // purchasePrice: res[0].purchasePrice,
        // sellingPrice: res[0].sellingPrice,
      };
      // if (purchasePrice) {
      //   obj.purchasePrice = purchasePrice
      //   obj.sellingPrice = sellingPrice

      //   obj.subTotal = purchasePrice * qty
      // } else {
      //   obj.sellingPrice = res[0]?.sellingPrice

      //   obj.subTotal = res[0]?.purchasePrice * qty
      //   obj.purchasePrice = res[0]?.purchasePrice
      // }

      setGeneralList((arr) => [...arr, obj]);
    }
    if (purchasePrice) {
      setTotPrice(totprice + purchasePrice * qty);
      setTotQty(totqty + parseInt(qty));
    } else {
      setTotPrice(totprice + res[0]?.purchasePrice * qty);
      setTotQty(totqty + parseInt(qty));
    }
    if (subQty || subPrice) {
      setSubPrice(subPrice + changePurPrice * qty);
      setSubQty(subQty + parseInt(qty));
    } else {
      setSubPrice(subPrice + changePurPrice * qty);
      setSubQty(subQty + parseInt(qty));
    }
  };
  console.log(medicines, "obj");
  const del = (index, val) => {
    if (val === 1) {
      setDelID(index);

      setMedicines(medicines.filter((val, i) => i !== index));

      //for remove that you choose index items
      const remove = medicines.splice(index, 1);
      setSubQty(subQty - remove[0]?.totalUnit);
      setSubPrice(
        subPrice - remove[0]?.purchasePrice * parseInt(remove[0]?.requestedQty),
      );
    }
    if (val === 2) {
      setDelID(index);

      setProcedures(procedures.filter((val, i) => i !== index));

      //for remove that you choose index items
      const remove = procedures.splice(index, 1);
      setSubQty(subQty - remove[0]?.totalUnit);
      setSubPrice(
        subPrice - remove[0]?.purchasePrice * parseInt(remove[0]?.requestedQty),
      );
    }
    if (val === 3) {
      setDelID(index);

      setProceduresAccess(proceduresAccess.filter((val, i) => i !== index));

      //for remove that you choose index items
      const remove = proceduresAccess.splice(index, 1);
      setSubQty(subQty - remove[0]?.totalUnit);
      setSubPrice(
        subPrice - remove[0]?.purchasePrice * parseInt(remove[0]?.requestedQty),
      );
    }
    if (val === 4) {
      setDelID(index);

      setGeneralList(generalList.filter((val, i) => i !== index));

      //for remove that you choose index items
      const remove = generalList.splice(index, 1);
      setSubQty(subQty - remove[0]?.totalUnit);
      setSubPrice(
        subPrice - remove[0]?.purchasePrice * parseInt(remove[0]?.requestedQty),
      );
    }
  };
  const handleBranchError = () => {
    Swal.fire({
      title: "Please Choose Branch",
      // text: 'You Created Purchase Request Data!',
      icon: "error",
      // showCancelButton: true,

      cancelButtonText: "Close",
    });
  };
  const save = () => {
    const data = {
      purchaseDate: date,
      requiredDate: reqDate,
      reason: reason,
      remark: remark,
      // relatedBranch: branch,
      medicineItems: medicines,
      procedureItems: procedures,
      accessoryItems: proceduresAccess,
      generalItems: generalList,
      totalQTY: totqty,
      totalPrice: totprice,
      supplierVoucher: supplierCode,
      supplierName: supplierName,
      code: code,
      seq: seq,
    };
    if (branch === "HO") {
    } else {
      data.relatedBranch = branch;
    }
    // if (relatedBankAcc) data.relatedBankAccount = relatedBankAcc
    // if (relatedCashAcc) data.relatedCashAccount = relatedCashAcc
    // alert(JSON.stringify(data))
    api.post("purchase-request", data).then(function (response) {
      Swal.fire({
        title: "Successful!",
        text: "You Created Purchase Request Data!",
        icon: "success",
        // showCancelButton: true,

        cancelButtonText: "Close",
      });
    });
  };
  return (
    <>
      {/* @include('sweet::alert') */}

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/purchase">
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className="breadcrumb-item active"></li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section class="content">
            <div class="container-fluid">
              <h5 className="font-weight-bold mt-3">
                Purchase Request Create Form
              </h5>
              <div className="row mt-3">
                <div className="col-9">
                  <div className="card">
                    <div className="card-body">
                      <div className="p-2">
                        {/* <div className='row'>
                          <div className='offset-4 col-2'>
                            <div className='form-check form-check-inline mt-2 '>
                              <input
                                className='form-check-input'
                                type='radio'
                                name='bank_cash'
                                id='bank'
                                value='1'
                                onClick={handleBankRadioChange}
                              />
                              &nbsp;
                              <label
                                className='form-check-label text-success'
                                for='bank'
                              >
                                Bank
                              </label>
                            </div>
                          </div>
                          <div className='col-2'>
                            <div className='form-check form-check-inline mt-2 px-4'>
                              <input
                                className='form-check-input'
                                type='radio'
                                name='bank_cash'
                                id='cash'
                                value='2'
                                onClick={handleCashRadioChange}
                              />
                              <label
                                className='form-check-label text-success'
                                for='cash'
                              >
                                Cash
                              </label>
                            </div>
                          </div>
                        </div> */}
                        <div className="row">
                          <div className="col-6 form-group">
                            <label htmlFor="">Purchase Code</label>
                            <input
                              type="text"
                              className="form-control"
                              value={code}
                              // onChange={e => setDate(e.target.value)}
                            />
                          </div>

                          <div className="col-6 form-group">
                            <label>Branch</label>
                            <select
                              name="currency"
                              id=""
                              className="form-control mt-1"
                              onchange="convert(this.value)"
                              // placeholder='Filter By Branches'
                              onChange={(e) => setBranch(e.target.value)}
                            >
                              <option hidden>Select Branch</option>
                              <option value="HO">HO</option>

                              {branchLists.map((option) => (
                                <option value={option._id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-6 form-group">
                            <label htmlFor="">Supplier Code</label>
                            <input
                              type="text"
                              className="form-control"
                              onChange={(e) => setSupplierCode(e.target.value)}
                            />
                          </div>
                          <div className="col-6 form-group">
                            <label htmlFor="">Supplier Name</label>
                            <input
                              type="text"
                              className="form-control"
                              onChange={(e) => setSupplierName(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-6">
                            <label htmlFor="">Purchase Request Date</label>
                            <input
                              type="date"
                              className="form-control"
                              onChange={(e) => setDate(e.target.value)}
                            />
                          </div>
                          <div className="col-6">
                            <label htmlFor="">Required Date</label>
                            <input
                              type="date"
                              className="form-control"
                              onChange={(e) => setReqDate(e.target.value)}
                            />
                          </div>
                          <div className="row">
                            <div className="col-6 mt-3">
                              <label htmlFor="">Reason</label>
                              <textarea
                                className="form-control"
                                onChange={(e) => setReason(e.target.value)}
                              />
                            </div>
                            <div className="col-6 mt-3">
                              <label htmlFor="">Remark</label>
                              <textarea
                                className="form-control"
                                onChange={(e) => setRemark(e.target.value)}
                              />
                            </div>
                          </div>

                          <hr className="mt-3" />
                          <div className="offset-1 col-10 mt-3">
                            <table className="table table-hover">
                              <thead>
                                <tr>
                                  {/* <th>#</th> */}
                                  <th scope="col">Name</th>
                                  <th scope="col">Qty</th>
                                  <th scope="col">Price</th>

                                  <th scope="col">Sub Total</th>
                                  <th scope="col">Expired Date</th>
                                  <th scope="col">Alert Date</th>
                                  {/* <th scope='col'>Action</th> */}
                                </tr>
                              </thead>
                              <tbody>
                                {medicines.map((med, index) => (
                                  <tr>
                                    {/* <th>{++index}</th> */}
                                    <th>{med.name}</th>
                                    <th>{med.requestedQty}</th>
                                    <th>{med.purchasePrice}</th>
                                    <th>{med.subTotal}</th>
                                    <th>{med.expiredDate}</th>
                                    <th>{med.alertDate}</th>
                                    {/* <th>
                                      <RxCross2
                                        onClick={() => del(index, 1)}
                                      />
                                    </th> */}
                                  </tr>
                                ))}
                                {procedures.map((pro, index) => (
                                  <tr>
                                    {/* <th>{++index}</th> */}
                                    <th>{pro.name}</th>
                                    <th>{pro.requestedQty}</th>
                                    <th>{pro.purchasePrice}</th>

                                    <th>{pro.subTotal}</th>
                                    <th>{pro.expiredDate}</th>
                                    <th>{pro.alertDate}</th>
                                    {/* <th>
                                      <RxCross2
                                        onClick={() => del(index, 2)}
                                      />
                                    </th> */}
                                  </tr>
                                ))}
                                {proceduresAccess.map((proacc, index) => (
                                  <tr>
                                    {/* <th>{++index}</th> */}
                                    <th>{proacc.name}</th>
                                    <th>{proacc.requestedQty}</th>
                                    <th>{proacc.purchasePrice}</th>

                                    <th>{proacc.subTotal}</th>
                                    <th>{proacc.expiredDate}</th>
                                    <th>{proacc.alertDate}</th>
                                    {/* <th>
                                      <RxCross2
                                        onClick={() => del(index, 3)}
                                      />
                                    </th> */}
                                  </tr>
                                ))}
                                {generalList.map((gen, index) => (
                                  <tr>
                                    {/* <th>{++index}</th> */}
                                    <th>{gen.name}</th>
                                    <th>{gen.requestedQty}</th>
                                    <th>{gen.purchasePrice}</th>

                                    <th>{gen.subTotal}</th>
                                    <th>{gen.expiredDate}</th>
                                    <th>{gen.alertDate}</th>
                                    {/* <th>
                                      <RxCross2
                                        onClick={() => del(index, 4)}
                                      />
                                    </th> */}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          <div className="col-6 mt-3">
                            <label htmlFor="">Total Quantity</label>
                            <input
                              type="number"
                              className="form-control"
                              value={totqty}
                            />
                          </div>
                          <div className="col-6 mt-3">
                            <label htmlFor="">Total Price</label>
                            <input
                              type="number"
                              className="form-control"
                              value={totprice}
                            />
                          </div>
                          {branch ? (
                            <Button className="mt-4" onClick={save}>
                              Save
                            </Button>
                          ) : (
                            <Button
                              className="mt-4"
                              onClick={handleBranchError}
                            >
                              Save
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-3">
                  <div className="card">
                    <div className="card-body">
                      <div className="p-2">
                        <div class="row form-group">
                          <label htmlFor="">Select Category</label>
                          <select
                            name=""
                            id=""
                            onChange={(e) => chgItem(e.target.value)}
                            className="form-control"
                          >
                            <option hidden>Choose Category</option>

                            <>
                              <option value="1">Medicine</option>
                              <option value="2">Procedure Medicine</option>
                              <option value="3">Procedure Accessories</option>
                              <option value="4">General Items</option>
                            </>
                          </select>
                        </div>
                        <div class="row form-group mt-3">
                          <label htmlFor="">Select Item</label>
                          <select
                            name=""
                            id=""
                            onChange={(e) => chgQty(e.target.value)}
                            className="form-control"
                          >
                            <option hidden>Choose Item</option>
                            {units.map((unit, i) => (
                              <option value={unit._id}>
                                {unit.medicineItemName ||
                                  unit.accessoryItemName ||
                                  unit.procedureItemName ||
                                  unit.generalItemName}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div class="row form-group mt-3">
                          <label htmlFor="">Unit</label>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue={unit}
                            disabled
                            onChange={(e) => setUnit(e.target.value)}
                          />
                        </div>
                        <div class="row form-group mt-3">
                          <label htmlFor="">Quantity</label>
                          <input
                            type="number"
                            className="form-control"
                            defaultValue={0}
                            onChange={(e) => setQty(e.target.value)}
                          />
                        </div>
                        <div class="row form-group mt-3">
                          <label htmlFor="">Expired Date</label>
                          <input
                            type="date"
                            className="form-control"
                            onChange={(e) => setExpDate(e.target.value)}
                          />
                        </div>
                        <div class="row form-group mt-3">
                          <label htmlFor="">Alert Date</label>
                          <input
                            type="date"
                            className="form-control"
                            onChange={(e) => setAlertDate(e.target.value)}
                          />
                        </div>
                        <div class="row form-group mt-3">
                          <label htmlFor="">Enter Last Purchase Price</label>
                          <input
                            type="number"
                            className="form-control"
                            value={purchasePrice}
                            onChange={(e) => setPurchasePrice(e.target.value)}
                          />
                        </div>
                        <div className="row text-center mt-4">
                          <Button onClick={addPurchase}>Add</Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

    </>
  );
};

export default Create;
